module.exports = __webpack_public_path__ + "img/logo_wechat_fe862af.283334ca.png";